<div id="layout" class="main-layout">
    <app-layout></app-layout>
</div>

<div class="modal-wrapper">
    <div class="modal" style="background-color: transparent;">
        <div class="o-block u-text-center u-fullscreen u-overflow-auto u-bg-muted">
            <div class="o-block__cell u-flex u-flexGrow-1 u-mb-medium u-p-big">
                <div class="u-m-auto ">
                    <div class="c-formCard o-block u-collapse u-bg-main u-shadow-medium u-p-medium u-pt-none _u-width-100p _u-mb-small">
                        <div class="o-block__cell">
                            <span class="c-formCard__icon c-button  c-button--big c-button--icon u-radius-circle u-font-huge">
                                <i class="fa fa-unlock-alt" aria-hidden="true" style="font-size: 2em"></i>
                            </span>
                        </div>
                        <div class="o-block__cell ">
                            <h2 class="u-font-regular loginTitle">Change Password</h2></div>
                        <form>
                            <div class="o-block__cell">
                                <div class="c-control u-width-100p">
                                    <div class="c-control__input-box">
                                        <input class="c-control__input" name="password" type="password"
                                               placeholder="Current Password" autocomplete="off" id="password"
                                               required="required" [(ngModel)]="password">
                                    </div>
                                </div>
                            </div>
                            <div class="o-block__cell">
                                <div class="c-control u-width-100p"
                                     [ngClass]="{'invalid-input': invalidPassword || invalidInput}">
                                    <div class="c-control__input-box">
                                        <input class="c-control__input" name="new_password" type="password"
                                               placeholder="New Password" autocomplete="off" id="new_password"
                                               required="required" [(ngModel)]="newPassword">
                                    </div>
                                </div>
                            </div>
                            <div class="o-block__cell">
                                <div class="c-control u-width-100p" [ngClass]="{'invalid-input': invalidInput}">
                                    <div class="c-control__input-box">
                                        <input class="c-control__input" name="confirm_new_password" type="password"
                                               placeholder="Confirm New Password" autocomplete="off"
                                               id="confirm_new_password" required="required"
                                               [(ngModel)]="confirmPassword">
                                    </div>
                                </div>
                            </div>
                            <div class="o-block__cell">
                                <button class="c-button c-button--block" style="margin-top: 20px;"
                                        (click)="changePassword()"><span>Change</span>
                                </button>
                            </div>
                        </form>
                        <div class="input-container">
                            <div style="text-transform: uppercase; text-align: center; color: #f00; display: inline-block; word-wrap: break-word; width: 240px;">
                                {{errorMessage}}
                            </div>
                        </div>
                        <div class="input-container">
                            <div class="change-password-cancel" style=""
                                 (click)="closeChangePswdPopup()">Cancel
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .modal-wrapper {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(76, 76, 76, 0.85);
        visibility: hidden;
        opacity: 0;
        -webkit-transition: all 0.25s ease-in-out;
        -moz-transition: all 0.25s ease-in-out;
        -o-transition: all 0.25s ease-in-out;
        transition: all 0.25s ease-in-out;
    }

    .modal-wrapper.open {
        opacity: 1;
        visibility: visible;
        z-index: 1001;
    }

    .modal {
        width: 600px;
        height: 400px;
        display: block;
        margin: 50% 0 0 -300px;
        position: relative;
        top: 50%;
        left: 50%;
        background: #fff;
        opacity: 0;
        -webkit-transition: all 0.5s ease-in-out;
        -moz-transition: all 0.5s ease-in-out;
        -o-transition: all 0.5s ease-in-out;
        transition: all 0.5s ease-in-out;
    }

    .modal-wrapper.open .modal {
        margin-top: -200px;
        opacity: 1;
    }


</style>
